import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'IDENTITY' });



// WEBPACK FOOTER //
// ./src/frontend/modules/address-book/entity/handlers.js